import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { propTypes, withFormsy } from 'formsy-react';
import { ReactSelectize, SimpleSelect } from 'react-selectize';
import Inputmask from "inputmask";
import { uuid } from '../utils/_helpers';

Inputmask.extendAliases({
  'currency': {
    prefix: '',
  },
  url: {
    mask: "\\http\\s://i{+}",
  }
});


class Field extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mask: {},
      name: '',
    }
    this.changeValue = this.changeValue.bind(this);
    this.renderFieldType = this.renderFieldType.bind(this);
    this.initScripts = this.initScripts.bind(this);
  }
  changeValue(event) {
    const value = event.currentTarget[this.props.item.type === 'checkbox' ? 'checked' : 'value'];
    this.props.setValue(value);
    if (this.props.onChange) {
      this.props.onChange(event, value);
    }
  }

  componentDidMount() {
    const id = uuid();
    this.id = id || '#';
  }

  initScripts() {
    if (this.props.mask && this.id) {
      const selector = document.getElementById(this.id);
      if (selector) {
        if (selector.inputmask) {
          selector.inputmask.remove()
        }
        selector.removeAttribute('style');
        Inputmask(this.props.mask).mask(selector);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.name !== this.state.name) {
      this.setState({ name: nextProps.name }, () => {
        this.initScripts();
      });
    }
  }

  renderFieldType(type, props) {
    const defaultProps = {
      ...props,
      onChange: this.changeValue,
      value: type === 'checkbox' ? Boolean(this.props.getValue()) : this.props.getValue() || '',
      checked: type === 'checkbox' && Boolean(this.props.getValue()) ? true : false,
    };
    let el;

    switch(type) {
      case 'textarea': {
        el = <textarea id={this.id} { ...defaultProps } />
        break;
      }
      case 'number': {
        el = <input id={this.id} type='text' { ...defaultProps } />
        break;
      }
      case 'simpleselect': {
        const options = this.props.item.options || {};
        const extra = this.props.item.optionsExtra || {};
        const searchForObj = Object.keys(options).find(itemKey => {
          const option = options[itemKey];
          return option.value === props.value;
        });
        const selected = options[searchForObj];
        el = (
          <SimpleSelect
            ref="select_currency"
            options = {[...extra, ...options]}
            placeholder = "Select a currency"
            theme = "material"
            hideResetButton={true}
            transitionEnter={true}
            value = {selected}
            onValueChange={(item) => {
              const extra = item ? { name: props.name, label: item.label } : {};
              const value = item ? item.value : '';
              this.props.onChange({ extra }, value);
            }}
          />
        )
        break;
      }
      case 'checkbox': {
        el = (
          <div className="cntr">
            <label htmlFor={this.id} className="label-cbx">
              <input id={this.id} type="checkbox" {...defaultProps} className="invisible" />
              <div className="checkbox">
                <svg width="20px" height="20px" viewBox="0 0 20 20">
                  <path d="M3,1 L17,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 L1,3 C1,1.8954305 1.8954305,1 3,1 Z"></path>
                  <polyline points="4 11 8 15 16 6"></polyline>
                </svg>
              </div>
              <span>&nbsp;{defaultProps.name || ''}</span>
            </label>
          </div>
        )
        break;
      }
      case 'tel': {
        el = <input id={this.id} type='text' { ...defaultProps } />
        break;
      }
      default: {
        el =<input id={this.id} type='text' { ...defaultProps } />
        break;
      }
    }

    return el;
  }
  render() {
    const { item, itemKey, name, required, validations, value, disabled } = this.props;
    const props = {
      name,
      type: item.type ? item.type : 'text',
      placeholder: item.name,
      name: itemKey,
      validations,
      value,
      required,
      disabled,
    };
    const className = `form-group ${this.props.showRequired() ? 'required' : ''} ${this.props.showError() ? 'error' : ''}`;
    const errorMessage = this.props.getErrorMessage();

    return (
      <div className={`group ${className}`}>
        {this.renderFieldType(item.type, props)}
        <label className="form-field-label">{(item.name || '').toLowerCase()}</label>
        <span className="highlight"></span>
        <span className="bar"></span>
        <span className='validation-error'>{errorMessage}</span>
      </div> 
    )
  }
}

Field.propTypes = {
  item: PropTypes.object.isRequired,
  itemKey: PropTypes.string.isRequired,
  ...propTypes,
};

export default withFormsy(Field);


// WEBPACK FOOTER //
// ./src/components/Field.js